<template>
  <v-layout row wrap>
    <v-flex xs12 class="text-xs-center">
      <v-alert :value="true" type="warning">Add your area of expertise/skill - Your limit is {{expertiseNo}}</v-alert>
      <!-- start of modal -->
      <v-dialog v-model="dialog" max-width="750px">
        <v-btn color="btnColor" dark slot="activator" class="mb-2" flat>
          <v-icon>add</v-icon>Add Expertise
        </v-btn>
        <v-card height="50vh">
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Add Expertise</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click="close">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar> 

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-autocomplete
                    :items="categories"
                    v-model="category"
                    v-on:input="getSubCategory(`${category}`)"
                    label="Type the Expertise Required"
                    single-line
                    item-text="category"
                    item-value="category"
                    required
                    class="expertise_select"
                    attach
                  ></v-autocomplete>

                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    :items="subcategories"
                    v-model="subcategory"
                    label="Sub Category"
                    single-line
                    item-text="name"
                    required
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <v-btn class="btnColor" dark @click="saveExpertise">
                    <v-icon left>save</v-icon>Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal -->
    </v-flex>

    <v-flex xs12 class="text-xs-left expertise-list">
          <div>
            <ul>
              <li v-for="(expertise, index) in user.expertise" v-bind:key="index">
                {{expertise.category}} - {{expertise.subcategory}}
                <v-btn icon @click="deleteModal(expertise)">
                  <v-icon color="red darken-1">delete</v-icon>
                </v-btn>
              </li>
            </ul>
          </div>
        </v-flex>


    <!-- snack -->
    <v-snackbar
      :timeout="timeout"
      top
      right
      v-model="expertiseSnackbar"
      color="red"
    >{{ expertiseError }}</v-snackbar>
    <!-- end -->

    <!-- Delete dialog -->
    <v-dialog v-model="deleteDialog" max-width="650px">
      <v-toolbar dense flat color="primary" dark>
        Confirmation
        <v-spacer></v-spacer>
        <v-btn icon @click.native="deleteDialog = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-layout wrap>
          <v-flex xs12 class="del pa-3">
            Are you sure you want to delete -
            <span style="color: red">{{deleteItem.category}}</span> - the expertise?
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-btn color="green darken-1" :loading="loader" small dark @click="deleteExpertise()">
              <v-icon>check</v-icon>yes
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of delete dialog -->
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ExpertiseData",
  components: {},
  computed: {
    ...mapGetters(["user"]),
    /*...mapGetters(["expertiseNo"])*/
  },
  props: {
    expertiseNo: {
      type: Number
    }
  },
  data() {
    return {
      autoUpdate: true,
      dialog: false,
      loader: false,
      deleteDialog: false,
      selectedCategories: [],
      expertiseSnackbar: false,
      expertiseError: "Please select expertise",
      timeout: 4000,
      category: null,
      subcategory: null,
      selectedCategory: {},
      categories: [],
      subcategories: [],
      deleteItem: {},
      isUpdating: false
    };
  },
  methods: {
    deleteModal(expertise) {
      this.deleteItem = expertise;
      this.deleteDialog = true;
    },
    deleteExpertise() {
      const dataArray = this.user.expertise;
      const category = dataArray.find(category => {
        return category._id === this.deleteItem._id;
      });

      const pos = dataArray.indexOf(category);
      if (pos === -1) {
        return;
      }
      dataArray.splice(pos, 1);
      const data = { expertise: dataArray }
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/user/update/" + this.user._id, data })
        .then(res => {
          self.$store.commit("setUser", res.user);
          self.loader = false;
          self.deleteItem = {};
          self.deleteDialog = false;
        });
    },
    getCategories() {
      this.$store.dispatch("get", "/expertise").then(res => {
        this.categories = res.expertiseCategories;
      });
    },
    getSubCategory(category) {
      this.subcategories = [];
      const data = this.categories.find(record => {
        return record.category === category;
      });
      this.selectedCategory = data;
      const qcategories = data.subcategories;
      if (qcategories) {
        qcategories.map(record => {
          const newRecord = { name: record };
          this.subcategories.push(newRecord);
        });
      }
    },
    saveExpertise() {
      const expertise = this.category;
      if (expertise == null) {
        this.expertiseSnackbar = true;
      } else {
        const details = {
          category: this.selectedCategory.category,
          url: this.selectedCategory.url,
          subcategory: this.subcategory
        };
        
        let expertiseArray;
        if (this.user.expertise.length == 0) {
          expertiseArray = [];
        } else {
          expertiseArray = this.user.expertise;
        }

        const expertise = expertiseArray.push(details);

        const data = {
          expertise: expertiseArray
        };
        //dispatch
        const self = this;
        const res = this.$store
          .dispatch("put", { url: "/user/update/" + this.user._id, data })
          .then(res => {
            self.$store.commit("setUser", res.user);
            self.dialog = false;
            self.category = null;
            self.subcategory = null;
          });
      }
    },
    close() {
      this.dialog = false;
    },
    remove(item) {
      const index = this.selectedCategories.indexOf(item.category);
      if (index >= 0) this.selectedCategories.splice(index, 1);
    }
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    }
  },
  created() {
    this.getCategories();
  }
};
</script>

<style>
.del {
  font-size: 22px;
}
.v-menu__content {
    max-height: 200px !important;
}
</style>